import React, { createContext, useState, useEffect } from "react";
import { Auth } from "aws-amplify";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(null); // User role (admin/vendor)
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const userattributes = user.attributes;
        console.log("userattributes", userattributes);

        const customgroup = userattributes?.["custom:groups"];
        console.log("customgroup", customgroup);

        let role = "unknown"; // Default role

        if (customgroup) {
          if (
            customgroup.includes("G_SSO_NMGOPS_ADMIN") ||
            customgroup.includes("G_NMGOPS_SSO_ADMIN_PROD")
          ) {
            role = "admin";
          } else if (
            customgroup.includes("G_SSO_NMGOPS_PRETICKET") ||
            customgroup.includes("G_NMGOPS_SSO_PRETICKET_PROD")
          ) {
            role = "preticket";
          } else if (
            customgroup.includes("G_SSO_NMGOPS_EXCEPTIONS") ||
            customgroup.includes("G_NMGOPS_SSO_EXCEPTIONS_PROD")
          ) {
            role = "vendor";
          }
        }

        console.log("userRole", role);
        setUserRole(role); //
        // setUserRole("test");
      } catch (error) {
        console.error("Error fetching user role:", error);
        setUserRole(null); // Reset role if error occurs
      } finally {
        setLoading(false); // Mark loading as complete
      }
    };

    fetchUserRole();
  }, []);

  return (
    <LoginContext.Provider value={{ userRole, loading }}>
      {children}
    </LoginContext.Provider>
  );
};
